export const DishSizes: Record<string, string[]> = {
  "paper-cup": ["100", "150", "180", "250", "300", "400", "other"],
  "plastic-cup": ["350", "500", "other"],
  "thermo-cup": [
    "60",
    "120",
    "170",
    "220",
    "260",
    "350",
    "430",
    "620",
    "other",
  ],
  "thermo-food-container": ["1-piece", "2-piece", "2-piece", "other"],
  "chinese-food-container": ["500", "750", "1000", "other"],
  bowl: ["130", "245", "350", "other"],
  "cardboard-hamburger-container": ["S", "M", "XL", "other"],
};
